import { FormControl, FormHelperText, MenuItem, Select } from '@mui/material';
import React from 'react';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { UpdateMeDTOSalutationEnum } from '../../api';

const SALUTATION_OPTIONS = [UpdateMeDTOSalutationEnum.Mr, UpdateMeDTOSalutationEnum.Ms, UpdateMeDTOSalutationEnum.Divers] as const;

type Props<T extends FieldValues> = {
  name: Path<T>;
  id?: string;
  labelId?: string;
  control: Control<T>;
  getLabel: (value: string) => string;
  errorText?: React.ReactNode;
  emptyLabel: React.ReactNode;
};

export function SalutationSelectControl<T extends FieldValues>({ control, name, id, labelId, getLabel, errorText, emptyLabel }: Props<T>) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <FormControl fullWidth error={fieldState.invalid}>
          <Select {...field} value={field.value ?? ''} id={id} labelId={labelId} fullWidth data-testid="salutation-select">
            <MenuItem value="" data-testid="salutation-option-empty">
              {emptyLabel}
            </MenuItem>
            {SALUTATION_OPTIONS.map(option => (
              <MenuItem key={option} value={option} data-testid={`salutation-option-${option}`}>
                {getLabel(option)}
              </MenuItem>
            ))}
          </Select>
          {fieldState.invalid && errorText && <FormHelperText>{errorText}</FormHelperText>}
        </FormControl>
      )}
    />
  );
}
